import { render, staticRenderFns } from "./subEvents.vue?vue&type=template&id=97e4926c&scoped=true"
import script from "./subEvents.vue?vue&type=script&lang=js"
export * from "./subEvents.vue?vue&type=script&lang=js"
import style0 from "./subEvents.vue?vue&type=style&index=0&id=97e4926c&prod&scoped=true&lang=less"
import style1 from "./subEvents.vue?vue&type=style&index=1&id=97e4926c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97e4926c",
  null
  
)

export default component.exports